<template>
  <div class="cf-flex cf-flex--column">
    <h3 class="cf-title cf-title--3">
      {{ content.ReceiptQrCodeInstructions.title }}:
    </h3>

    <div class="cf-flex cf-flex--column cf-flex--gap-20">
      <cf-formatted-content :content="content.ReceiptQrCodeInstructions.metadata.subtitle" />

      <div class="cf-flex cf-flex--align-center cf-flex--justify-center">
        <vue-qrcode
          class="cf-image cf-image--auto-w cf-image--border"
          :value="receipt.redemptionQrCodeValue"
          :scale="6"
        />
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';

  export default {
    name: 'ReceiptQrCodeInstructions',

    components: {
      CfFormattedContent
    },

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content'])
    }
  };
</script>
